import { ExpandedContent, Separator, EmptyState } from "../../Compartilhado/styles";
import { IItemHistoricoPlano } from "../../../../types";
import BlocoPrincipal from "../../Compartilhado/Blocos/BlocoPrincipal";
import { CampoValor } from "../../Compartilhado/Blocos/BlocoPrincipal";

interface ExpandedContentProps {
  item: IItemHistoricoPlano;
  isExpanded?: boolean;
}

function formatarValorMonetario(valor: any): string {
  if (valor === null || valor === undefined) return '—';
  if (typeof valor === 'number') {
    return `R$ ${valor.toFixed(2).replace('.', ',')}`;
  }
  return String(valor);
}

function mapearDadosPlanoCriado(payload: any): CampoValor[] {
  if (!payload) return [];

  const campos: CampoValor[] = [];

  if (payload.nome) {
    campos.push({ campo: 'Nome', valor: payload.nome });
  }
  if (payload.quantidade_creditos != null) {
    campos.push({ campo: 'Quantidade de Créditos', valor: String(payload.quantidade_creditos) });
  }
  if (payload.valor_plano != null) {
    campos.push({ campo: 'Valor do Plano', valor: formatarValorMonetario(payload.valor_plano) });
  }
  if (payload.valor_credito != null) {
    campos.push({ campo: 'Valor/Crédito', valor: formatarValorMonetario(payload.valor_credito) });
  }
  if (payload.valor_onboarding != null) {
    campos.push({ campo: 'Valor Onboarding', valor: formatarValorMonetario(payload.valor_onboarding) });
  }
  if (payload.validade_creditos_dias != null) {
    campos.push({ campo: 'Validade (dias)', valor: String(payload.validade_creditos_dias) });
  }
  if (payload.status) {
    campos.push({ campo: 'Status', valor: payload.status === 'ativo' ? 'Ativo' : 'Inativo' });
  }

  return campos;
}

export default function ExpandedContentPlanoCriado({ item, isExpanded }: ExpandedContentProps) {
  const payload = typeof item.payload === 'string' ? JSON.parse(item.payload) : item.payload;
  const campos = mapearDadosPlanoCriado(payload);

  if (campos.length === 0) {
    return (
      <ExpandedContent>
        <Separator />
        <EmptyState>Nenhum dado disponível.</EmptyState>
      </ExpandedContent>
    );
  }

  return (
    <ExpandedContent>
      <Separator />
      <BlocoPrincipal campos={campos} />
    </ExpandedContent>
  );
}
